<template>
    <CRow>
        <CCol col="12" lg="10">
            <CCard>
                <CCardHeader>
                    <strong>Создание блюда</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CInput
                            v-model="dish.title"
                            label="Название"
                            placeholder="Введите название блюда"
                        />
                        <CRow class="pl-3 pb-3">Лейблы</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="12">
                            <div v-for="label in allLabels" :key="label.id" class="form-check">
                                <input 
                                class="form-check-input"
                                type="checkbox"
                                :id="`label-${label.id}`"
                                :value="label.id"
                                v-model="selectedLabels"
                                />
                                <label class="form-check-label" :for="`label-${label.id}`">
                                {{ label.title }}
                                </label>
                            </div>
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3">Скидка</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="promotionsOptions"
                                    :value.sync="selectedPromotion"
                                    placeholder="Выберите скидку..."
                                />
                            </CCol>
                        </CRow>
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"
                        />
                        <CTextarea
                            v-model="dish.description"
                            label="Описание"
                            placeholder="Краткое описание блюда (не более 255 символов)"
                        />
                        <CInput
                            v-model="dish.quantity"
                            label="Количество (шт)"
                        />
                        <CInput
                            v-model="dish.composition"
                            label="Состав"
                            placeholder="Состав блюда (не более 255 символов)"
                        />
                        <CInput
                            v-model="dish.allergens"
                            label="Содержит"
                            placeholder="Аллергены, если есть (не более 255 символов)"
                        />
                        <CInput v-model="dish.price" label="Цена" />

                        <CSelect
                            :value.sync="dish.vat"
                            :horizontal="true"
                            :options="vatOptions"
                            label="Значения ставки НДС"
                            placeholder="Выберите значения ставки НДС"
                        />

                        <CSelect
                            horizontal
                            label="Единицы измерения"
                            :options="unitsOptions"
                            :value.sync="dish.units"
                            placeholder="Выберите единицы измерения..."
                        />

                        <CInput v-model="dish.weight" :label="`Вес (${UNITS_ENUM[dish.units]})`" />

                        <CInput v-model="dish.calories" label="Килокалории (ккал)" />
                        <CInput v-model="dish.protein" label="Белки" step="0.1" />
                        <CInput v-model="dish.fat" label="Жиры" step="0.1" />
                        <CInput v-model="dish.carbohydrates" label="Углеводы" step="0.1" />

                        <div class="overflow-hidden border border-gray-300 rounded-md p-2 mb-4">
                            <CRow class="pl-3 pb-3">
                                <strong>Подборки для стола заказов</strong>
                            </CRow>
                            <CRow>
                                <CCol tag="label" sm="3" class="col-form-label">Завтрак</CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="dish.table_order_breakfast"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol tag="label" sm="3" class="col-form-label">Обед</CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="dish.table_order_lunch"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol tag="label" sm="3" class="col-form-label">Ужин</CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="dish.table_order_dinner"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol tag="label" sm="3" class="col-form-label">Перекус</CCol>
                                <CCol sm="9">
                                    <CSwitch
                                        color="dark"
                                        shape="pill"
                                        variant="opposite"
                                        :checked.sync="dish.table_order_snack"
                                    />
                                </CCol>
                            </CRow>
                        </div>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Энергетик (18+)
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.energetic"
                                />
                                <small class="form-text text-muted">
                                    Отметьте, если товар является энергетиком или требует подтверждения возраста 18+
                                </small>
                            </CCol>
                        </CRow>

                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Популярное блюдо
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.popular"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="dish.enabled"
                                />
                            </CCol>
                        </CRow>
                        <CRow class="pl-3 pb-3">Категории</CRow>
                        <CRow class="pl-3 pb-3">
                            <CCol sm="4">
                                <CSelect
                                    horizontal
                                    :options="categoriesOptions"
                                    :value.sync="selectedCategory"
                                    placeholder="Выберите категорию..."
                                />
                            </CCol>
                            <CCol sm="8">
                                <CButton
                                    color="primary"
                                    class="ml-3"
                                    @click="addCategory">Добавить</CButton>
                            </CCol>
                        </CRow>
                        <CRow class="pl-3">
                            <table class="table">
                                <draggable v-model="categories" tag="tbody">
                                    <tr v-for="category in categories" :key="category.title">
                                        <td><CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" /></td>
                                        <td>{{ category.title }}</td>
                                        <td><CButton @click="removeCategory(category.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                    </tr>
                                </draggable>
                            </table>
                        </CRow>
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="create"
                    >Создать</CButton
                    >
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';
    import { UNITS_ENUM, UNITS } from '@/utils/units';

    export default {
        name: 'DishCreate',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },

        data() {
            return {
                restaurant: {},
                dish: {
                    title: '',
                    picture: '',
                    description: '',
                    quantity: null,
                    ingridients_limit: null,
                    composition: '',
                    allergens: '',
                    price: null,
                    units: UNITS.GRAM,
                    weight: null,
                    calories: null,
                    popular: false,
                    enabled: true,
                    position: 100,
                    carbohydrates: null,
                    protein: null,
                    fat: null,
                    labels: [],
                    energetic: false,
                    table_order_breakfast: false,
                    table_order_lunch: false,
                    table_order_dinner: false,
                    table_order_snack: false,
                },
                categories: [],
                promotions: [],
                allCategories: [],
                selectedCategory: null,
                selectedPicture: null,
                selectedPromotion: null,
                UNITS_ENUM,
                allLabels: [],
                selectedLabels: [],
                vatOptions: [
                    { value: null, label: 'НДС не облагается' },
                    { value: 0, label: 'НДС 0%' },
                    { value: 10, label: 'НДС 10%' },
                    { value: 20, label: 'НДС 20%' },
                    { value: 22, label: 'НДС 22%' },
                    { value: 110, label: 'Расчетный НДС 10/110' },
                    { value: 120, label: 'Расчетный НДС 20/120' },
                ],
            };
        },

        computed: {
            categoriesOptions: function() {
                const categoriesOptions = [];
                this.allCategories.forEach(category => {
                    categoriesOptions.push({
                        value: category.id,
                        label: category.title
                    });
                });
                return categoriesOptions;
            },
            promotionsOptions: function() {
                const promotionsOptions = [];
                this.promotions.forEach(promotion => {
                    promotionsOptions.push({
                        value: promotion.id,
                        label: promotion.title
                    });
                });
                promotionsOptions.push({
                    value: 'null',
                    label: 'Без',
                })
                return promotionsOptions;
            },
            unitsOptions() {
                return Object.entries(UNITS_ENUM).map(([value, label]) => ({ value: +value, label }));
            }
        },

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios.get('/common-promotions')
                .then(resp => {
                    this.promotions = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${err.response.data.error}`);
                });
            Vue.axios
                .get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${err.response.data.error}`);
                });
            Vue.axios.get('/restaurants/get-all-categories/' + id)
                .then(resp => {
                    this.setAllCategories(resp.data);
                })
                .catch(err => {
                    this.$root.$emit('showError', `Ошибка загрузки данных. \n\n${err.response.data.error}`);
                });
            Vue.axios.get('/labels')
                .then((resp) => {
                    this.allLabels = resp.data;
                })
                .catch((err) => {
                    this.$root.$emit(
                    'showError',
                    `Ошибка загрузки лейблов. \n\n${err.response.data.error}`
                    );
                });
        },

        methods: {
            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },

            async create() {
                if (!this.dish.title) {
                    this.$root.$emit('showError', 'Укажите название блюда.');
                    return;
                }
                if (!this.dish.price) {
                    this.$root.$emit('showError', 'Укажите стоимость.');
                    return;
                }
                if (!this.dish.weight) {
                    this.$root.$emit('showError', 'Укажите вес.');
                    return;
                }
                if (!this.dish.calories) {
                    this.dish.calories = 0;
                }
                if (!this.dish.carbohydrates) {
                    this.dish.carbohydrates = 0;
                }
                if (!this.dish.protein) {
                    this.dish.protein = 0;
                }
                if (!this.dish.fat) {
                    this.dish.fat = 0
                };

                if(this.selectedPromotion) {
                    this.dish.promotion_id = this.selectedPromotion;
                }
                this.dish.labels = this.selectedLabels;

                this.dish.title = this.dish.title ? String(this.dish.title) : '';
                this.dish.description = this.dish.description ? String(this.dish.description) : '';
                this.dish.composition = this.dish.composition ? String(this.dish.composition) : '';
                this.dish.allergens = this.dish.allergens ? String(this.dish.allergens) : '';
                this.dish.quantity = this.dish.quantity ? +this.dish.quantity : 0;
                this.dish.price = this.dish.price ? +this.dish.price : 0;
                this.dish.weight = this.dish.weight ? +this.dish.weight : 0;
                this.dish.restaurant_id = +this.restaurant.id;
                this.dish.calories = this.dish.calories ? +this.dish.calories : 0;
                this.dish.fat = this.dish.fat ? +String(this.dish.fat).replace(',', '.') : 0;
                this.dish.carbohydrates = this.dish.carbohydrates ? +String(this.dish.carbohydrates).replace(',', '.') : 0;
                this.dish.protein = this.dish.protein ? +String(this.dish.protein).replace(',', '.') : 0;
                this.dish.table_order_breakfast = !!this.dish.table_order_breakfast;
                this.dish.table_order_lunch = !!this.dish.table_order_lunch;
                this.dish.table_order_dinner = !!this.dish.table_order_dinner;
                this.dish.table_order_snack = !!this.dish.table_order_snack;
                // Загружаем картинку
                if (this.selectedPicture) {
                    const this_ = this;
                    let formData = new FormData();
                    formData.append('file', this.selectedPicture);
                    const { data } = await Vue.axios.post('/files/upload', formData);
                    this_.dish.picture = data.filename;
                }
                Vue.axios
                    .post(
                        '/restaurants/' + this.restaurant.id + '/dishes/create',
                        this.dish
                    )
                    .then(dish => {
                        const categoriesToSave = [];
                        let index = 0;
                        this.categories.forEach(category => {
                            category.position = ++index;
                            categoriesToSave.push(category);
                        });
                        Vue.axios.post('/restaurants/' + this.restaurant.id +'/dishes/categories/' + dish.data.id, { categories: categoriesToSave })
                            .then(() => {
                                this.$router.push({
                                    path:
                                        '/restaurants/' +
                                        this.restaurant.id +
                                        '/dishes/' +
                                        dish.data.id,
                                });
                            })
                            .catch(err => {
                                this.$root.$emit('showError', `Ошибка сохранения. \n\n${err.response.data.error}`);
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', `Ошибка создания. \n\n${err.response.data.error}`);
                    });
            },

            setAllCategories(categories) {
                const _allCategories = [];
                categories.forEach(category => {
                    if(this.addCategoryOption(category.id)) {
                        _allCategories.push({
                            id: category.id,
                            title: category.title
                        });
                    }
                });
                this.allCategories = _allCategories;
            },

            addCategoryOption(id) {
                let contains = false;
                for(var i = 0; i < this.categories.length; i++) {
                    if(this.categories[i].id === id) {
                        contains = true;
                    }
                }
                return !contains;
            },

            addCategory() {
                for(var i = 0; i < this.allCategories.length; i++) {
                    if(this.selectedCategory === this.allCategories[i].id) {
                        this.categories.push({
                            id: this.allCategories[i].id,
                            title: this.allCategories[i].title,
                            position: 0
                        });
                        delete this.allCategories[i];
                        break;
                    }
                }
                this.setAllCategories(this.allCategories);
            },

            removeCategory(id) {
                const _categories = [];
                for(var i = 0; i < this.categories.length; i++) {
                    if(id != this.categories[i].id) {
                        _categories.push(this.categories[i]);
                    }
                }
                this.categories = _categories;
            },

            goBack() {
                this.$router.push({
                    path:
                        '/restaurants/' +
                        this.restaurant.id +
                        '/dishes/' +
                        this.dish.id,
                });
            },
        },
    };
</script>
